import { useTranslate } from '@tolgee/react';
import { useCallback } from 'react';
import { ATTRIBUTE_NS } from 'src/bootstrap/constants';
import { AttributesAliases } from 'src/generated/dict';
import { LocaleValuesFragment } from 'src/generated/operations';
import { isLocaleValuesFragment } from 'src/common/types/isLocaleValuesFragment.ts';

const AttributeIDs = Object.values(AttributesAliases);

export type BelimoTranslate = (
    value: LocaleValuesFragment | string | null | undefined,
    detectNamespace?: boolean
) => string;

export const useBelimoTranslate = (): BelimoTranslate => {
    const { t } = useTranslate();

    return useCallback((
        value: LocaleValuesFragment | string | null | undefined,
        detectNamespace: boolean = true,
    ) => {
        const valueComposed = isLocaleValuesFragment(value)
            ? value.localized.join(', ') || ''
            : String(value || '');

        const ns = detectNamespace && AttributeIDs.includes(valueComposed) ? ATTRIBUTE_NS : undefined;

        return valueComposed.substring(0, 1) === '@'
            ? t(valueComposed.replace('@', ''), valueComposed, { ns })
            : t(valueComposed, valueComposed, { ns });
    }, [t]);
};
